import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import type { VehicleSort } from '@/lib/vehicleFilter';
export interface VehicleSortSelectProps {
  value: VehicleSort;
  onChange: (val: VehicleSort) => void;
}
export function VehicleSortSelect(t0) {
  const $ = _c(13);
  const {
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <InputLabel id="vehicle-sort-select-label">Sort by</InputLabel>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = value || "default";
  let t3;
  if ($[1] !== onChange) {
    t3 = e => {
      onChange(e.target.value);
    };
    $[1] = onChange;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t10;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MenuItem value="default">Default</MenuItem>;
    t5 = <MenuItem value="price-asc">Lowest Price</MenuItem>;
    t6 = <MenuItem value="price-desc">Highest Price</MenuItem>;
    t7 = <MenuItem value="year-desc">Newest</MenuItem>;
    t8 = <MenuItem value="year-asc">Oldest</MenuItem>;
    t9 = <MenuItem value="odometer-asc">Lowest KMs</MenuItem>;
    t10 = <MenuItem value="odometer-desc">Highest KMs</MenuItem>;
    $[3] = t10;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t10 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t11;
  if ($[10] !== t2 || $[11] !== t3) {
    t11 = <FormControl>{t1}<Select autoWidth={true} label="Sort by" labelId="vehicle-sort-select-label" id="vehicle-sort-select" value={t2} onChange={t3} size="small">{t4}{t5}{t6}{t7}{t8}{t9}{t10}</Select></FormControl>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
}